import {Button, Form, Input, Toast} from "antd-mobile";
import {useNavigate} from "react-router-dom";
import {salesmanLogin} from "../../common/ApiAction";
import {kLoginInfo, TOASTDURATION} from "../../common/Utils";
import {useTranslation} from "react-i18next";


const Login = () => {
    const  navigate = useNavigate()
    const { t } = useTranslation();

    const onFinish = (values: any) => {
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        salesmanLogin(values).then((res:any) => {
            Toast.clear();
            if (!res.executed) {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            } else {
                const curUser: API.CurrentUser = {
                    id: res.data.id,
                    userName: res.data.userName,
                    salesName: res.data.salesName,
                    mobile: res.data.mobile
                }
                window.localStorage.setItem(kLoginInfo, JSON.stringify(curUser));
                navigate('/tab')
            }
        }).catch((err: any) => {
            Toast.show({icon: 'fail', content: err.message, duration: TOASTDURATION})
        })
    }

    return <div style={{
        backgroundColor: '#F5F6FA',
        height: '100vh',
        display: "flex",
        flexDirection: "column",
        padding: '0 12px',
        justifyContent: "center",
        textAlign: "center"
    }}>
        <Form
            onFinish={onFinish}
            mode={'card'}
            layout='horizontal'
            footer={<Button shape='rounded' block type='submit' color='primary' size='middle'>{t('submit')}</Button>}>
            <Form.Header>{t('login_title')}</Form.Header>
            <Form.Item name='username' rules={[{ required: true, message: t('username_required') }]}>
                <Input placeholder={t('username_placeholder')} />
            </Form.Item>
            <Form.Item name='password' rules={[{ required: true, message: t('password_required') }]}>
                <Input type={"password"} placeholder={t('password_placeholder')} />
            </Form.Item>
        </Form>
    </div>
}
export default Login
